// Translations
import landing from '../views/landing/translations/de'

// Translation: Register (German)
export default Object.freeze({
	name: '',
	views: { landing }
})
